export const materialConstants = {
  FETCH: 'FETCH',
  MATERIALS: 'MATERIALS',
  MATERIAL: 'MATERIAL',
  ADD_MATERIAL: 'ADD_MATERIAL',
  UPDATE_MATERIAL: 'UPDATE_MATERIALS',
  DELETE_MATERIAL: 'DELETE_MATERIAL',
  SOLID_MATERIAL: 'SOLID_MATERIAL',
};
